export default abstract class HasLabel {
    getLabel(long: boolean = false): string {
        return this.toString(long);
    }

    abstract toString(long?: boolean): string;
}
